import { RefResolver } from "./RefResolver";
import { Device } from "./Device";
import { DeviceKey, IfKey } from "./Keys";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";

export interface Ref {
	Resolve(resolvers: RefResolver);
} 
	
export class DeviceRef implements Ref, ObjectSerializer {

	public DeviceKey: DeviceKey;
	public Device: Device;

	constructor(device?: Device, deviceKey?: DeviceKey) {
		if (device) {
			this.DeviceKey = device.CreateKey();
			this.Device = device;
		} else {
			this.Device = null;
			this.DeviceKey = deviceKey;
		}
	}

	public Resolve(resolver: RefResolver) {
		resolver.Resolve(this);
	}

	public Write(obj: any, context: any): void {
		this.DeviceKey.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		this.DeviceKey = new DeviceKey();
		this.DeviceKey.Read(obj, context);
		if (!context.ref_list)
			context.ref_list = [];
		context.ref_list.push(this);
	}

}

export class IfRef implements Ref, ObjectSerializer {
	public IfKey: IfKey;
	public Device: Device;
	public IfEntry: IfEntry;

	constructor(device?: Device, ifEntry?: IfEntry, ifKey?: IfKey)
	{
		if (device && ifEntry) {
			this.IfKey = IfKey.Create(device, ifEntry);
			this.Device = device;
			this.IfEntry = ifEntry;
		}
		else if (ifKey) {
			this.IfKey = ifKey;
			this.Device = null;
			this.IfEntry = null;
		}
		else {
			this.IfKey = null;
			this.Device = null;
			this.IfEntry = null;
		}
	}

	public Resolve(resolver: RefResolver):void {
		resolver.ResolveRef(this);
	}

	public Write(obj: any, context: any): void {
		this.IfKey.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		this.IfKey = new IfKey();
		this.IfKey.Read(obj, context);
		if (!context.ref_list)
			context.ref_list = [];
		context.ref_list.push(this);
	}
}
